// extracted by mini-css-extract-plugin
module.exports = {"surveyTitle":"_10CvjwfLcf-xd7l2"};